module.exports = __webpack_public_path__ + "static/media/search-character.135c4fe9.png";